import React, { PureComponent } from 'react';
import { bool, func, object, string } from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Dialog from '@material-ui/core/Dialog';
import AlternatingHeader from './components/AlternatingHeader';
import LoginController from '../LoginController/connected';
import { colors } from '../../constants/colors';
import { resetLoginData } from '../../actions/login';

export const LOGIN_SIGN_UP_MODAL = 'login sign up modal';

const Root = styled.div`
  position: relative;
`;

const Close = styled.div`
  width: 25px;
  height: 25px;
  position: absolute;
  cursor: pointer;
  right: 20px;
  top: 20px;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.squid};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.squid};
  }
`;

const mapDispatchToProps = dispatch => ({
  resetLoginData: () => dispatch(resetLoginData()),
});

class LoginSignUpModal extends PureComponent {
  static propTypes = {
    fullScreen: bool,
    open: bool,
    onClose: func.isRequired,
    runtime: object,
    login: object,
    resetLoginData: func.isRequired,
  };

  render() {
    const { fullScreen, open, onClose, runtime, login, ...otherProps } = this.props;
    return (
      <Dialog
        open={open}
        fullScreen={fullScreen}
        maxWidth="sm"
        onClose={onClose}
        fullWidth
        onEnter={this.props.resetLoginData}
      >
        <Root>
          <Close onClick={onClose} />
          <AlternatingHeader
            runtime={runtime}
            isModal
            closeModal={onClose}
            loginAction={login.action}
          />
          <LoginController preventRedirectAfterLogin isModal {...otherProps} />
        </Root>
      </Dialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'sm' })(
  connect(
    null,
    mapDispatchToProps
  )(LoginSignUpModal)
);
